import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaRegUserCircle } from "react-icons/fa";
import { BiKey, BiStop, BiUser } from "react-icons/bi";
import { signIn } from "../actions/adminActions";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const Login = () => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [logging, setLogging] = useState(false);
  const [formData, setFormData] = useState({
    admin: "",
    password: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLogging(true);
    const dataCredential = {
      admin: formData.admin,
      password: formData.password,
      // new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Manila" })).getTime() + 1 * 60000
    };

    const response = await dispatch(signIn(dataCredential, navigate));

    if (response?.param === "invalid") {
      toast.error(`${response.msg}`);
    }
    if (response?.param === "loggedin") {
      toast.error(`${response.msg}`);
    }
    setLogging(false);
  };

  useEffect(() => {
    return () => setFormData({ admin: "", password: "" });
  }, []);

  useEffect(() => {
    toast.error(state?.message);
  }, [state]);
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  return (
    <div className="login-container">
      <ToastContainer
        autoClose={3000}
        toastStyle={{ backgroundColor: "black", color: "white" }}
      />
      <form className="signin-container" onSubmit={handleSubmit}>
        <FaRegUserCircle className="logo" />
        <h2>Admin Login</h2>
        <div className="custom-style-input">
          <BiUser />
          <input
            type="text"
            autoComplete="off"
            id="text"
            name="admin"
            onChange={handleChange}
          />
        </div>
        <div className="custom-style-input">
          <BiKey />
          <input
            type="password"
            id="password"
            name="password"
            onChange={handleChange}
          />
        </div>
        <button disabled={logging} type="submit" className="authBtn">
          {logging ? (
            <div>
              <FontAwesomeIcon icon={faCog} className="fa-spin" />
              {" Please wait "}
            </div>
          ) : (
            "Login"
          )}
        </button>
      </form>
    </div>
  );
};

export default Login;
